import { MrbBaseRouteStore } from "mrb/core";
import { LoadioContentProfileService, LoadioArtistService, LoadioGenreService } from "common/services";

class LoadioContentProfileArtistsRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);
        this.contentProfileService = rootStore.createApplicationService(LoadioContentProfileService);
        this.artistService = rootStore.createApplicationService(LoadioArtistService);
        this.genreService = rootStore.createApplicationService(LoadioGenreService);
    }

    async findGenres(params) {
        try {
            const response = await this.genreService.find(params);
            return response.data;
        } catch (err) {
            this.rootStore.notificationStore.error(
                "Unable to load genres for filtering.",
                err
            );
            return { item: [], page: 1, recordsPerPage: 0, totalRecords: 0 };
        }
    }

    async getProfile(id) {
        const response = await this.contentProfileService.get(id);
        return response.data;
    }

    async findArtists(params) {
        const response = await this.artistService.find(params);
        return response.data;
    }

    async assignArtists(profileId, artistIds) {
        const response = await this.contentProfileService.assignArtists(profileId, artistIds);
        return response.data;
    }

    async unassignArtists(profileId, artistIds) {
        const response = await this.contentProfileService.unassignArtists(profileId, artistIds);
        return response.data;
    }

    async enableAllArtists(profileId, genreId = null, searchQuery = null) {
        const response = await this.contentProfileService.enableAllArtists(profileId, genreId, searchQuery);
        return response.data;
    }

    async disableAllArtists(profileId, genreId = null, searchQuery = null) {
        const response = await this.contentProfileService.disableAllArtists(profileId, genreId, searchQuery);
        return response.data;
    }
}

export default LoadioContentProfileArtistsRouteStore;
